module.exports = __webpack_public_path__ + "static/media/020.92706612.jpg";